import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validates the following logic:
// matched min can be 0% but if it is, then unmatched min has to be 1+%
// if unmatched is 0% then matched has to be 1+%
export function contributionRatePercentageValidator(
  matchedMinControl: string,
  unmatchedMinControl: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;

    const matchedMin = control.parent.get(matchedMinControl);
    const unmatchedMin = control.parent.get(unmatchedMinControl);

    if (!matchedMin || !unmatchedMin) return null;

    const matched = Number(matchedMin.value) || 0;
    const unmatched = Number(unmatchedMin.value) || 0;

    // Only set error on the control that is 0 and whose sibling is < 1
    if (control === matchedMin && matched === 0 && unmatched < 1) {
      return { invalidMinimumRatePercentage: true };
    }
    if (control === unmatchedMin && unmatched === 0 && matched < 1) {
      return { invalidMinimumRatePercentage: true };
    }

    return null;
  };
}
